import * as prismic from '@prismicio/client'

// Fill in your repository name
export const repositoryName = 'philips-ecommerce'

export const client = prismic.createClient(repositoryName, {
  // If your repository is private, add an access token
  accessToken: 'MC5ZekZuZWhNQUFMeFZSWDRE.77-9Wu-_vRgn77-977-9c--_vWR1ayvvv70E77-977-9NAdX77-9Uu-_vS7vv73vv73vv73vv70577-977-977-9',
})
